import classNames from "classnames";
import { Image, Pickable, Typography } from "components";
import styles from "./PatientOption.module.css";

interface PatientOptionProps {
  image: string;
  label: string;
  active: boolean;
  onClick(): void;
}

const PatientOption: React.FC<PatientOptionProps> = ({
  image,
  label,
  active,
  onClick,
}) => {
  return (
    <Pickable className={styles.pickable} active={active} onClick={onClick}>
      <Image src={image} alt={label} ratio="2:1" />
      <span className={classNames(styles.label, active && styles.active)}>
        <Typography size={1} weight={500} whiteSpace="pre" align="center">
          {label}
        </Typography>
      </span>
    </Pickable>
  );
};

export default PatientOption;
